<stx-generic-wide-page>
  <stx-report-header>
    {{ 'report.speech_assessments' | translate }}
  </stx-report-header>
  <stx-report-filters [reportConfig]="reportConfig" (applyFilters)="applyFilters($event)"></stx-report-filters>
  @if (reportService.filtersReady$ | async) {
  <stx-speech-treatments-report-table></stx-speech-treatments-report-table>
  }
</stx-generic-wide-page>
